import { render, staticRenderFns } from "./BigButtonBar.vue?vue&type=template&id=3c12cdd4&"
import script from "./BigButtonBar.vue?vue&type=script&lang=ts&"
export * from "./BigButtonBar.vue?vue&type=script&lang=ts&"
import style0 from "./BigButtonBar.vue?vue&type=style&index=0&id=3c12cdd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports